import { type FieldValues } from './types';
import { CreateServicesHubDto, ServiceHubFaq } from '../../../../../types/serviceHub.types';

export const mapToFieldValues = (
  serviceInfo: CreateServicesHubDto | undefined | null,
): FieldValues => ({
    fileInfo: serviceInfo?.fileInfo ?? null,

    slug: serviceInfo?.slug ?? '',

  serviceNameEn: serviceInfo?.serviceNameEn ?? '',
  serviceNameUk: serviceInfo?.serviceNameUk ?? '',
  serviceNameRu: serviceInfo?.serviceNamePl ?? '',
  serviceNamePl: serviceInfo?.serviceNamePl ?? '',

  serviceSubtitleEn: serviceInfo?.serviceSubtitleEn ?? '',
  serviceSubtitleRu: serviceInfo?.serviceSubtitleRu ?? '',
  serviceSubtitleUk: serviceInfo?.serviceSubtitleUk ?? '',
  serviceSubtitlePl: serviceInfo?.serviceSubtitlePl ?? '',

  serviceShortnamePl: serviceInfo?.serviceShortnamePl ?? '',
  serviceShortnameUk: serviceInfo?.serviceShortnameUk ?? '',
  serviceShortnameRu: serviceInfo?.serviceShortnameRu ?? '',
  serviceShortnameEn: serviceInfo?.serviceShortnameEn ?? '',

  seoTitleEn: serviceInfo?.seoTitleEn ?? '',
  seoTitlePl: serviceInfo?.seoTitlePl ?? '',
  seoTitleRu: serviceInfo?.seoTitleRu ?? '',
  seoTitleUk: serviceInfo?.seoTitleUk ?? '',

  seoDescriptionUk: serviceInfo?.seoDescriptionUk ?? '',
  seoDescriptionRu: serviceInfo?.seoDescriptionRu ?? '',
  seoDescriptionEn: serviceInfo?.seoDescriptionEn ?? '',
  seoDescriptionPl: serviceInfo?.seoDescriptionPl ?? '',


});
